import { Component, Input, ViewChild, Output, EventEmitter, OnInit, OnDestroy, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { map, startWith } from 'rxjs/operators';

import * as uuid from 'uuid';
import { NgModel } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import { UtilityService } from '../../../../services/utility/utility.service';
import { MatAutocompleteTrigger, MatAutocomplete } from '@angular/material/autocomplete';

@Component({
  selector: 'sd-grid-autocomplete-control',
  templateUrl: './grid-autocomplete-control.component.html',
  styleUrls: [
    './grid-autocomplete-control.component.css',
    '../../../../assets/css/input.scss'
  ]
})

// tslint:disable-next-line: component-class-suffix
export class GridAutocompleteControl implements OnInit, AfterViewInit, OnDestroy {
  private initialized = false;
  private pModel: any;
  private pItems: any[] = [];
  private flag = false;
  name = uuid.v4();
  private cItems: any[] = [];
  private limit = 30;
  @Input() loading = false;
  @Input() valueField: string;
  @Input() displayField: string;
  @Input() set items(items: any[] | Observable<any[]>) {
    if (!items) {
      items = [];
    }
    if (Array.isArray(items)) {
      this.pItems = items || [];
      if (this.initialized) {
        this.onChanges();
        this.formModel?.control.setValue(this.formModel?.control.value);
        this.reload();
      }
    } else if (items?.pipe) {
      this.subcription.add(items?.subscribe(values => {
        this.pItems = values || [];
        if (this.initialized) {
          this.onChanges();
          this.formModel?.control.setValue(this.formModel?.control.value);
          this.reload();
        }
      }));
    }
  }
  filteredItems: Observable<any[]>;

  cModel: any;
  @Input() set model(value: any) {
    this.pModel = value;
    if (this.initialized) {
      this.onChanges();
      this.reload();
    }
  }

  @Output() modelChange = new EventEmitter();
  @Output() sdChange = new EventEmitter();
  @Output() search = new EventEmitter();

  // Optional
  @Input() required: boolean;
  @Input() disabled: boolean;

  @ViewChild('formModel', { static: true }) formModel: NgModel;
  @ViewChild(MatAutocompleteTrigger, { read: MatAutocompleteTrigger }) autocompleteTrigger: MatAutocompleteTrigger;
  subcription = new Subscription();
  visibility = true;
  constructor(
    private ref: ChangeDetectorRef,
    private utilityService: UtilityService) {
  }

  ngOnInit() {
    this.filteredItems = this.formModel.valueChanges.pipe(
      startWith<string | { [key: string]: string }>(''),
      map(item => typeof item === 'string' ? item : (item ? item[this.displayField] : '')),
      map(this.filter)
    );
  }

  ngAfterViewInit() {
    this.onChanges();
    this.reload();
    this.initialized = true;
    this.ref.detectChanges();
  }

  ngOnDestroy() {
    this.subcription?.unsubscribe();
  }

  private onChanges = () => {
    this.cModel = this.pModel;
    if (this.flag || (!this.valueField && !this.displayField)) {
      this.cItems = this.pItems.map(e => ({
        code: e
      }));
      this.flag = true;
      this.valueField = 'code';
      this.displayField = 'code';
    } else {
      this.cItems = this.pItems;
    }
    // this.formModel?.control.updateValueAndValidity({ onlySelf: false, emitEvent: true });
  }

  private reload = () => {
    this.formModel?.control.updateValueAndValidity({ onlySelf: false, emitEvent: true });
  }

  onChange(value: any) {
    if (typeof value !== 'string') {
      this.cModel = value ? value[this.valueField] : undefined;
      this.modelChange.emit(this.cModel);
      this.sdChange.emit(value);
    } else {
      if (!value) {
        this.cModel = undefined;
        this.modelChange.emit(this.cModel);
        this.sdChange.emit(this.cModel);
        this.reload();
        this.autocompleteTrigger?.openPanel();
        // this.clear();
      }
      this.search.emit(value);
    }
  }

  filter = (value: string): { [key: string]: string }[] => {
    let results = this.cItems;
    if (value) {
      results = this.cItems.filter(item => {
        return this.utilityService.changeAliasLowerCase(item[this.displayField])
          .indexOf(this.utilityService.changeAliasLowerCase(value)) !== -1;
      });
    }
    return results.filter((item, index) => index < this.limit);
  }

  displayFn = (value: string | { [key: string]: string }): string | undefined => {
    if (typeof value === 'string') {
      if (!this.cItems) {
        return value;
      }
      const selectedItem = this.cItems.find(item => item[this.valueField] === value);
      if (selectedItem) {
        return selectedItem[this.displayField];
      }
      return value;
    } else {
      return value ? value[this.displayField] : undefined;
    }
  }
  clear = ($event?: any) => {
    $event?.stopPropagation();
    this.formModel?.control.setValue(undefined);
  }
}
